export const formatPrice = (price: number, currency: string = 'MAD', locale: string = 'fr-MA'): string => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
    }).format(price);
};
